import { useEffect } from 'react';
import { dispatcher } from 'dispatcher';
import { usePublicApi as usePublicAPICore } from '@core/js/hooks/usePublicAPI/usePublicAPI';

export const usePublicApi = () => {
    usePublicAPICore(); // We're using original hook, so no need to change this file on c-merge

    useEffect(() => {
        window.Playtech = window.Playtech || {};
        /**
         * Public API is available in run time of Portal SPA running.
         * @memberOf Playtech
         * @namespace Playtech.API
         */
        window.Playtech.API = {
            ...window.Playtech.API,
            dispatcher
        };
    }, []);
};
